import { createEvent } from "library/local-events/index.mjs"
let eventDefinitions = {}
const BasketItemAdded = createEvent("BasketItemAdded")
const Uncache = createEvent("Uncache")
const LocalDatabaseEvents = createEvent("Database")
const LocalDatabaseWillGet = LocalDatabaseEvents("WillGet")
const LocalDatabasePut = LocalDatabaseEvents("Put")
const LocalDatabaseGet = LocalDatabaseEvents("Get")
const LocalDatabaseUpdate = LocalDatabaseEvents("Update")
const LocalUpdateTable = LocalDatabaseEvents("UpdateTable")
const RecordUpdate = createEvent("Record.Update")
const Table = createEvent("Table")
const AddRow = Table("AddRow")
const DeleteRow = Table("DeleteRow")
const TableUpdate = Table("Update")
const TableFlushCache = Table("FlushCache")
const ClientChanged = createEvent("ClientChanged")
const Authorization = createEvent("Authorization", {
    isAsync: true,
})
const VerifiedUser = createEvent("VerifiedUser", {
    isAsync: true,
})
const ValidateToken = createEvent("ValidateToken", {
    isAsync: true,
})
const DecorateUser = createEvent("DecorateUser", {
    isAsync: true,
})
const EnsureClient = createEvent("EnsureClient", {
    isAsync: true,
})
const RecycleItem = createEvent("RecycleItem", {
    isAsync: true,
})
const RestoreItem = createEvent("RestoreItem", {
    isAsync: true,
    extract: (v) => v[0].handleFile,
})
const ScheduleFilter = createEvent("ScheduleFilter", {
    isAsync: true,
    extract: (v) => v[0].rows,
})
const ValidateWebhookRegistration = createEvent("ValidateWebhookRegistration", {
    isAsync: true,
    extract: (v) => v[0].isValid,
})
const WebhookRegistered = ValidateWebhookRegistration("WebhookRegistered")
const SendWebhooks = createEvent("SendWebhooks", {
    isAsync: true,
})
const AIModelConfigurationChange = createEvent("AIModelConfigurationChange", {
    isAsync: true,
})
eventDefinitions.ClientChanged = ClientChanged
eventDefinitions.ScheduleFilter = ScheduleFilter
eventDefinitions.BasketItemAdded = BasketItemAdded
eventDefinitions.Uncache = Uncache
eventDefinitions.LocalDatabaseEvents = LocalDatabaseEvents
eventDefinitions.LocalDatabaseUpdate = LocalDatabaseUpdate
eventDefinitions.LocalUpdateTable = LocalUpdateTable
eventDefinitions.RecordUpdate = RecordUpdate
eventDefinitions.Table = Table
eventDefinitions.AddRow = AddRow
eventDefinitions.DeleteRow = DeleteRow
eventDefinitions.TableUpdate = TableUpdate
eventDefinitions.TableFlushCache = TableFlushCache
eventDefinitions.LocalDatabasePut = LocalDatabasePut
eventDefinitions.LocalDatabaseGet = LocalDatabaseGet
eventDefinitions.LocalDatabaseWillGet = LocalDatabaseWillGet
eventDefinitions.EnsureClient = EnsureClient
eventDefinitions.Authorization = Authorization
eventDefinitions.VerifiedUser = VerifiedUser
eventDefinitions.ValidateToken = ValidateToken
eventDefinitions.DecorateUser = DecorateUser
eventDefinitions.RecycleItem = RecycleItem
eventDefinitions.RestoreItem = RestoreItem
eventDefinitions.ValidateWebhookRegistration = ValidateWebhookRegistration
eventDefinitions.WebhookRegistered = WebhookRegistered
eventDefinitions.SendWebhooks = SendWebhooks
eventDefinitions.AIModelConfigurationChange = AIModelConfigurationChange
eventDefinitions.StartDataLoad = createEvent("StartDataLoad")
eventDefinitions.DataLoaded = createEvent("DataLoaded")
eventDefinitions.FlushAllCache = createEvent("FlushAllCache", {
    isAsync: true,
})
eventDefinitions.FlushGraphQLCache = createEvent("FlushGraphQLCache", {
    isAsync: true,
})
eventDefinitions.ReadGroup = createEvent("ReadGroup", {
    isAsync: true,
})
eventDefinitions.ReadTree = createEvent("ReadTree", {
    isAsync: true,
})
eventDefinitions.recycle = RecycleItem.raiseAsync
eventDefinitions.ReInitialiseServer = createEvent("ReInitialiseServer", {
    isAsync: true,
})
eventDefinitions.WriteGroup = createEvent("WriteGroup", {
    isAsync: true,
})
eventDefinitions.GetDemands = createEvent("GetDemands", {
    extract: (v) => v[0].demands,
})
eventDefinitions.AdoptClient = createEvent("AdoptClient")
eventDefinitions.InvalidLink = createEvent("InvalidLink")
eventDefinitions.TestTrigger = createEvent("TestTrigger")
eventDefinitions.ActionTransformer = createEvent("ActionTransformer", {
    isAsync: true,
    extract: (v) => v[0],
    expose: "transform",
    parameters: ([type]) => ({
        actions: [],
        type,
    }),
})
eventDefinitions.CompleteAction = createEvent("CompleteAction", {
    extract: (v) => v[0].isComplete,
    isAsync: true,
})
eventDefinitions.PermissionsUpdated = createEvent("PermissionsUpdated")
eventDefinitions.LicencePurchased = createEvent("LicencePurchased")
eventDefinitions.ConfigureDemands = createEvent("ConfigureDemands", {
    extract: (v) => v[0].demands,
    isAsync: true,
    extended: true,
})
eventDefinitions.ConfigureShareLinkDemands = createEvent("ConfigureShareLinkDemands", {
    extract: (v) => v[0].demands,
    isAsync: true,
    extended: true,
})
eventDefinitions.CompletedAction = createEvent("CompleteAction", {
    isAsync: true,
})
eventDefinitions.TreeUpdated = createEvent("TreeUpdated")
eventDefinitions.TreeCacheKeys = createEvent("TreeCacheKeys", {
    extract: (v) => v[0].keys,
})
eventDefinitions.ServerReady = createEvent("ServerReady")

// Auditing
eventDefinitions.AuditEvent = createEvent("AuditEvent")
eventDefinitions.createAudit = function createAudit({ shortDescription, longDescription, type, referenceId, payload }) {
    return eventDefinitions.AuditEvent.raiseAsync({
        shortDescription,
        longDescription,
        type,
        referenceId,
        payload,
    })
}
eventDefinitions.PredicateSchedules = createEvent("PredicateSchedules", {
    extract: (v) => v[0].handled,
    isAsync: true,
})
eventDefinitions.ShowSnackbar = createEvent("ShowSnackbar")
eventDefinitions.showSnackBarToInstance = (
    message,
    options = {
        variant: "info",
        autoHideDuration: 5000,
    }
) => eventDefinitions.ShowSnackbar.raiseForCurrentInstance(message, options)
eventDefinitions.DatabaseIndex = createEvent("DatabaseIndex")
eventDefinitions.SwitchUserUrl = createEvent("SwitchUserUrl")
eventDefinitions.SwitchUserClient = eventDefinitions.SwitchUserUrl
eventDefinitions.SettingUpdated = createEvent("SettingUpdated", {
    isAsync: true,
})
eventDefinitions.ShareLinkValidateRule = createEvent("ShareLinkValidateRule", {
    isAsync: true,
    extract: (v) => v[0].valid,
})
eventDefinitions.SharingLinkUpdated = createEvent("SharingLinkUpdated")
eventDefinitions.RefreshTreeRoots = createEvent("RefreshTreeRoots")
eventDefinitions.AuthCode = createEvent("AuthCode")
eventDefinitions.UserCreated = createEvent("UserCreated")
eventDefinitions.HighMemoryUsage = createEvent("HighMemoryUsage")
eventDefinitions.CreateUser = createEvent("CreateUser")
eventDefinitions.CanUserWrite = createEvent("CanUserWrite")
eventDefinitions.PreventUserWrite = createEvent("PreventUserWrite")
eventDefinitions.EnsurePersonalAccount = createEvent("EnsurePersonalAccount")
eventDefinitions.UserLoggedOut = createEvent("UserLoggedOut")
eventDefinitions.ClientDemands = createEvent("ClientDemands", {
    extract: (v) => v[0].demands,
    expose: "get",
    parameters: {
        demands: [],
    },
})
eventDefinitions.DemandAudit = createEvent("DemandAudit", {
    extract: (v) => v[0].demands,
    expose: "verify",
})
eventDefinitions.ApplySharingFilter = createEvent("ApplySharingFilter")
eventDefinitions.ValidateDraft = createEvent("ValidateDraft", {
    extract: (v) => v[0].draft,
    expose: "validate",
    parameters: (v) => ({
        draft: v[0],
    }),
})
eventDefinitions.ValidateAction = createEvent("ValidateAction", {
    extract: (v) => v[0].include,
    parameters: ([action]) => ({
        include: true,
        action,
    }),
    expose: "validate",
    isAsync: true,
})
eventDefinitions.Invalidate = createEvent("Invalidate")
eventDefinitions.FilterTask = createEvent("FilterTask", {
    extract: (v) => v[0].include,
    expose: "filter",
    parameters: ([task]) => ({
        include: true,
        task,
    }),
})
eventDefinitions.HelpUpdated = createEvent("HelpUpdated")
eventDefinitions.RemovedNameSpace = createEvent("RemovedNameSpace")
eventDefinitions.SetNamespaceForUser = createEvent("SetNamespaceForUser")
eventDefinitions.GetNamespaceForUser = createEvent("GetNamespaceForUser")
eventDefinitions.JobCompleted = createEvent("JobCompleted")
eventDefinitions.JobFailed = createEvent("JobFailed")
eventDefinitions.GetMockLicenses = createEvent("GetMockLicenses")
eventDefinitions.AIScheduleList = createEvent("AIScheduleList")
eventDefinitions.AIResponse = createEvent("AIResponse")
eventDefinitions.GetAvailableDemands = createEvent("GetAvailableDemands")
eventDefinitions.Scheduler = createEvent("Scheduler")
eventDefinitions.CustomSkillDeleted = createEvent("CustomSkillDeleted", {
    isAsync: true,
})
eventDefinitions.Refresher = createEvent("Refresher")
eventDefinitions.clientRefresh = function clientRefresh(name) {
    eventDefinitions.Refresher.raiseForCurrentInstance(name).catch(console.error)
}
eventDefinitions.WatchChanged = createEvent("WatchChanged")
eventDefinitions.OverridePermission = createEvent("OverridePermission", {
    isAsync: true,
    extract: (v) => v[0].override,
})
eventDefinitions.IsLicensed = createEvent("IsLicensed", {
    isAsync: true,
    extract: (v) => v[0].isLicensed,
    expose: "check",
    parameters: ([schedule]) => ({
        isLicensed: false,
        schedule,
    }),
})
eventDefinitions.XmlFormatTask = createEvent("XmlFormatTask")
eventDefinitions.XmlScheduleGroups = createEvent("XmlScheduleGroups")
eventDefinitions.ServerOnline = createEvent("ServerOnline")
eventDefinitions.RegisterMapping = createEvent("RegisterMapping")
eventDefinitions.BusySystem = createEvent("BusySystem")
eventDefinitions.EndSession = createEvent("EndSession")
eventDefinitions.ProvideExcelData = createEvent("ProvideExcelData")
eventDefinitions.ProvideXMLData = createEvent("ProvideXMLData")
eventDefinitions.ProvidePDFData = createEvent("ProvidePDFData")
eventDefinitions.ShareLinkDownloadProgress = createEvent("ShareLinkDownloadProgress")
eventDefinitions.systemBusy = function (message) {
    if (typeof message === "string") {
        eventDefinitions.BusySystem.raiseForCurrentInstance({
            id: "system_busy",
            message,
            running: !!message,
        })
    } else {
        eventDefinitions.BusySystem.raiseForCurrentInstance({
            id: "system_busy",
            ...message,
        })
    }
}
eventDefinitions.LegacyClientDataMigrated = createEvent("LegacyClientDataMigrated")
eventDefinitions.FeatureSwitchedOn = createEvent("FeatureSwitchedOn")
eventDefinitions.FeatureSwitchedOff = createEvent("FeatureSwitchedOff")
eventDefinitions.AIProviders = createEvent("AIProviders")
eventDefinitions.ServerWillListen = createEvent("ServerWillListen")
eventDefinitions.ProcessIsReady = createEvent("ProcessIsReady")
eventDefinitions.DataExportRequestEmail = createEvent("DataExportRequestEmail")
eventDefinitions.RegimeGenerated = createEvent("RegimeGenerated")
eventDefinitions.CheckResolverRedirect = createEvent("CheckResolverRedirect")
eventDefinitions.ServerFinished = createEvent("ServerFinished")
eventDefinitions.ServerDied = createEvent("ServerDied")
eventDefinitions.AuditFilter = createEvent("AuditFilter")
eventDefinitions.ApproveAuditFilter = createEvent("ApproveAuditFilter", (v) => v[0].filters)
eventDefinitions.ExtendExecutionContext = createEvent("ExtendExecutionContext")
eventDefinitions.ScopedDemands = createEvent("ScopedDemands")
eventDefinitions.PostAuthorization = createEvent("PostAuthorization")
eventDefinitions.GetAvailableApplications = createEvent("GetAvailableApplications")
eventDefinitions.PermissionDenied = createEvent("PermissionDenied")
eventDefinitions.ClientSelectableForUser = createEvent("ClientSelectableForUser", {
    extract: (v) => v[0].selectable,
    expose: "check",
    parameters: ([user]) => ({ selectable: false, user }),
})
eventDefinitions.AppAuthorization = createEvent("AppAuthorization", {
    isAsync: true,
    extract: (v) => v[0].appDemands,
    expose: "getAppDemands",
    parameters: ([header]) => ({ appDemands: {}, header }),
})
eventDefinitions.TriggerResolutionScan = createEvent("TriggerResolutionScan")
eventDefinitions.DiscoverVisitors = createEvent("DiscoverVisitors")
eventDefinitions.GetQueryVisitors = eventDefinitions.DiscoverVisitors("GetQueryVisitors")
export { ClientChanged }
export { ScheduleFilter }
export { BasketItemAdded }
export { Uncache }
export { LocalDatabaseEvents }
export { LocalDatabaseUpdate }
export { LocalUpdateTable }
export { RecordUpdate }
export { Table }
export { AddRow }
export { DeleteRow }
export { TableUpdate }
export { TableFlushCache }
export { LocalDatabasePut }
export { LocalDatabaseGet }
export { LocalDatabaseWillGet }
export { EnsureClient }
export { Authorization }
export { VerifiedUser }
export { ValidateToken }
export { DecorateUser }
export { RecycleItem }
export { RestoreItem }
export { ValidateWebhookRegistration }
export { WebhookRegistered }
export { SendWebhooks }
export { AIModelConfigurationChange }
export const { StartDataLoad } = eventDefinitions
export const { DataLoaded } = eventDefinitions
export const { FlushAllCache } = eventDefinitions
export const { FlushGraphQLCache } = eventDefinitions
export const { ReadGroup } = eventDefinitions
export const { ReadTree } = eventDefinitions
export const { recycle } = eventDefinitions
export const { ReInitialiseServer } = eventDefinitions
export const { WriteGroup } = eventDefinitions
export const { GetDemands } = eventDefinitions
export const { AdoptClient } = eventDefinitions
export const { InvalidLink } = eventDefinitions
export const { TestTrigger } = eventDefinitions
export const { ActionTransformer } = eventDefinitions
export const { CompleteAction } = eventDefinitions
export const { PermissionsUpdated } = eventDefinitions
export const { LicencePurchased } = eventDefinitions
export const { ConfigureDemands } = eventDefinitions
export const { ConfigureShareLinkDemands } = eventDefinitions
export const { CompletedAction } = eventDefinitions
export const { TreeUpdated } = eventDefinitions
export const { TreeCacheKeys } = eventDefinitions
export const { ServerReady } = eventDefinitions
export const { AuditEvent } = eventDefinitions
export const { createAudit } = eventDefinitions
export const { PredicateSchedules } = eventDefinitions
export const { ShowSnackbar } = eventDefinitions
export const { showSnackBarToInstance } = eventDefinitions
export const { DatabaseIndex } = eventDefinitions
export const { SwitchUserUrl } = eventDefinitions
export const { SwitchUserClient } = eventDefinitions
export const { SettingUpdated } = eventDefinitions
export const { ShareLinkValidateRule } = eventDefinitions
export const { SharingLinkUpdated } = eventDefinitions
export const { RefreshTreeRoots } = eventDefinitions
export const { AuthCode } = eventDefinitions
export const { UserCreated } = eventDefinitions
export const { HighMemoryUsage } = eventDefinitions
export const { CreateUser } = eventDefinitions
export const { CanUserWrite } = eventDefinitions
export const { PreventUserWrite } = eventDefinitions
export const { EnsurePersonalAccount } = eventDefinitions
export const { UserLoggedOut } = eventDefinitions
export const { ClientDemands } = eventDefinitions
export const { DemandAudit } = eventDefinitions
export const { ApplySharingFilter } = eventDefinitions
export const { ValidateDraft } = eventDefinitions
export const { ValidateAction } = eventDefinitions
export const { Invalidate } = eventDefinitions
export const { FilterTask } = eventDefinitions
export const { HelpUpdated } = eventDefinitions
export const { RemovedNameSpace } = eventDefinitions
export const { SetNamespaceForUser } = eventDefinitions
export const { GetNamespaceForUser } = eventDefinitions
export const { JobCompleted } = eventDefinitions
export const { JobFailed } = eventDefinitions
export const { GetMockLicenses } = eventDefinitions
export const { AIScheduleList } = eventDefinitions
export const { AIResponse } = eventDefinitions
export const { GetAvailableDemands } = eventDefinitions
export const { Scheduler } = eventDefinitions
export const { CustomSkillDeleted } = eventDefinitions
export const { Refresher } = eventDefinitions
export const { clientRefresh } = eventDefinitions
export const { WatchChanged } = eventDefinitions
export const { OverridePermission } = eventDefinitions
export const { IsLicensed } = eventDefinitions
export const { XmlFormatTask } = eventDefinitions
export const { XmlScheduleGroups } = eventDefinitions
export const { ServerOnline } = eventDefinitions
export const { RegisterMapping } = eventDefinitions
export const { BusySystem } = eventDefinitions
export const { EndSession } = eventDefinitions
export const { ProvideExcelData } = eventDefinitions
export const { ProvideXMLData } = eventDefinitions
export const { ProvidePDFData } = eventDefinitions
export const { ShareLinkDownloadProgress } = eventDefinitions
export const { systemBusy } = eventDefinitions
export const { LegacyClientDataMigrated } = eventDefinitions
export const { FeatureSwitchedOn } = eventDefinitions
export const { FeatureSwitchedOff } = eventDefinitions
export const { AIProviders } = eventDefinitions
export const { ServerWillListen } = eventDefinitions
export const { ProcessIsReady } = eventDefinitions
export const { DataExportRequestEmail } = eventDefinitions
export const { RegimeGenerated } = eventDefinitions
export const { CheckResolverRedirect } = eventDefinitions
export const { ServerFinished } = eventDefinitions
export const { ServerDied } = eventDefinitions
export const { AuditFilter } = eventDefinitions
export const { ApproveAuditFilter } = eventDefinitions
export const { ExtendExecutionContext } = eventDefinitions
export const { ScopedDemands } = eventDefinitions
export const { PostAuthorization } = eventDefinitions
export const { GetAvailableApplications } = eventDefinitions
export const { PermissionDenied } = eventDefinitions
export const { ClientSelectableForUser } = eventDefinitions
export const { AppAuthorization } = eventDefinitions
export const { TriggerResolutionScan } = eventDefinitions
export const { DiscoverVisitors } = eventDefinitions
export const { GetQueryVisitors } = eventDefinitions
